import { Text, View } from '@react-pdf/renderer'
import PDFCell from '@/components/ReportPDF/PDFCell'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFRow from '@/components/ReportPDF/PDFRow'
import PDFTitle from '@/components/ReportPDF/PDFTitle'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'

const Header = ({ title }) => (
  <PDFCell flex={2} style={{ padding: 0, alignItems: 'stretch' }}>
    <PDFCell
      style={{
        backgroundColor: `#4c82bf`,
        border: 'none',
      }}
    >
      <Text style={{ color: 'white' }}>{title}</Text>
    </PDFCell>
    <PDFRow style={{ margin: -0.5 }}>
      <PDFCell
        flex={1}
        style={{
          backgroundColor: '#d7e0ed',
        }}
      >
        <Text>人數</Text>
      </PDFCell>
      <PDFCell
        flex={1}
        style={{
          backgroundColor: '#d7e0ed',
        }}
      >
        <Text>比率</Text>
      </PDFCell>
    </PDFRow>
  </PDFCell>
)

const formatPercent = value => {
  if (value != null) {
    return Number(value).toFixed(2) // 強制保留兩位小數
  }
  return '0.00' // 無效值回傳 '0.00'
}

const ReportRow = ({ tempData }) => {
  const { tempId, report } = tempData
  const {
    userCount,
    openCount,
    openPercent,
    linkCount,
    linkPercent,
    fileCount,
    filePercent,
    textCount,
    textPercent,
  } = report

  return (
    <PDFRow width={1075} marginLeft={-85}>
      <PDFCell flex={0.5} style={{ backgroundColor: '#e8ecf2' }}>
        <Text>{tempId}</Text>
      </PDFCell>

      <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
        <Text>{userCount}</Text>
      </PDFCell>

      <PDFCell flex={2} style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}>
        <PDFRow style={{ margin: -0.5 }}>
          <PDFCell flex={1}>
            <Text>{openCount || 0}</Text>
          </PDFCell>
          <PDFCell flex={1}>
            <Text>{formatPercent(openPercent)}%</Text>
          </PDFCell>
        </PDFRow>
      </PDFCell>

      <PDFCell flex={2} style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}>
        <PDFRow style={{ margin: -0.5 }}>
          <PDFCell flex={1}>
            <Text>{linkCount || 0}</Text>
          </PDFCell>
          <PDFCell flex={1}>
            <Text>{formatPercent(linkPercent)}%</Text>
          </PDFCell>
        </PDFRow>
      </PDFCell>

      <PDFCell flex={2} style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}>
        <PDFRow style={{ margin: -0.5 }}>
          <PDFCell flex={1}>
            <Text>{fileCount || 0}</Text>
          </PDFCell>
          <PDFCell flex={1}>
            <Text>{formatPercent(filePercent)}%</Text>
          </PDFCell>
        </PDFRow>
      </PDFCell>

      <PDFCell flex={2} style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}>
        <PDFRow style={{ margin: -0.5 }}>
          <PDFCell flex={1}>
            <Text>{textCount || 0}</Text>
          </PDFCell>
          <PDFCell flex={1}>
            <Text>{formatPercent(textPercent)}%</Text>
          </PDFCell>
        </PDFRow>
      </PDFCell>
    </PDFRow>
  )
}

const Chapter4Sub2Page = ({ reportData, setPage }) => {
  const { tempResults } = reportData || {}

  return (
    <PDFPage hideTitleDivider reportData={reportData}>
      <PDFTitle hideDivider>4.2 受測者行為依樣版統計</PDFTitle>
      <Text
        render={({ pageNumber }) => {
          setPage({ chap4_2: pageNumber })
        }}
      />

      <View>
        <PDFParagraph>
          {'    '}依照
          <Text style={{ fontWeight: 'bold', fontSize: 20 }}>不同類型之範本郵件</Text>
          ，統計
          <Text>「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」</Text>
          人數比率。 下表依照
          <Text style={{ fontWeight: 'bold', fontSize: 20 }}>樣板與受測人數</Text>
          統計之
          <Text>「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」</Text>
          之人數統計報表：
        </PDFParagraph>

        <PDFRow style={{ fontWeight: 'bold' }} width={1075} marginLeft={-85}>
          <PDFCell
            flex={0.5}
            style={{
              backgroundColor: `#4c82bf`,
            }}
          >
            <Text style={{ color: 'white' }}>樣板</Text>
          </PDFCell>
          <PDFCell
            flex={1}
            style={{
              backgroundColor: `#4c82bf`,
            }}
          >
            <Text style={{ color: 'white' }}>受測人數</Text>
          </PDFCell>
          <Header title={'瀏覽信件'} />

          <Header title={'點閱連結'} />

          <Header title={'開啟附件'} />

          <Header title={'輸入資料'} />
        </PDFRow>

        {/* <PDFRow>
          <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
            <Text>{tempId}</Text>
          </PDFCell>

          <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
            <Text>{groupNumber}</Text>
          </PDFCell>

          <PDFCell
            flex={2}
            style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}
          >
            <PDFRow style={{ margin: -0.5 }}>
              <PDFCell flex={1}>
                <Text>{openEmail || 0}</Text>
              </PDFCell>
              <PDFCell flex={1}>
                <Text>{openEmailPercent}</Text>
              </PDFCell>
            </PDFRow>
          </PDFCell>

          <PDFCell
            flex={2}
            style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}
          >
            <PDFRow style={{ margin: -0.5 }}>
              <PDFCell flex={1}>
                <Text>{linkedClicked || 0}</Text>
              </PDFCell>
              <PDFCell flex={1}>
                <Text>{linkedClickedPercent}</Text>
              </PDFCell>
            </PDFRow>
          </PDFCell>

          <PDFCell
            flex={2}
            style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}
          >
            <PDFRow style={{ margin: -0.5 }}>
              <PDFCell flex={1}>
                <Text>{attachmentOpened || 0}</Text>
              </PDFCell>
              <PDFCell flex={1}>
                <Text>{attachmentOpenedPercent}</Text>
              </PDFCell>
            </PDFRow>
          </PDFCell>

          <PDFCell
            flex={2}
            style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}
          >
            <PDFRow style={{ margin: -0.5 }}>
              <PDFCell flex={1}>
                <Text>{attachmentOpened || 0}</Text>
              </PDFCell>
              <PDFCell flex={1}>
                <Text>{attachmentOpenedPercent}</Text>
              </PDFCell>
            </PDFRow>
          </PDFCell>
        </PDFRow> */}

        {tempResults?.map((tempData, index) => (
          <ReportRow key={`${index + 1}`} tempData={tempData} />
        ))}
      </View>
    </PDFPage>
  )
}

export default Chapter4Sub2Page
